/* eslint-disable class-methods-use-this */
import { Requests } from '@nx-smartmonkey/shared/helpers';
import { Project } from '../../domain/project/Project';
import { Supervisor } from '../../domain/supervisor/Supervisor';
import { SupervisorDTO } from '../../domain/supervisor/SupervisorDTO';
import { SupervisorMapper } from '../../mappers/supervisor/SupervisorMapper';
import { SessionRepository } from '../session/SessionRepository';
import { SupervisorRepository } from './SupervisorRepository';

export class SupervisorRepositoryApi implements SupervisorRepository {
  constructor(private requests: Requests, private sessionRepository: SessionRepository) {}
  async fetch({ supervisorId }: { supervisorId: string }): Promise<Supervisor> {
    const response = await this.requests.get({
      uri: `/v2/supervisor/${supervisorId}`,
      headers: this.sessionRepository.getAuthenticationHeader(),
    });

    const data = response.data as SupervisorDTO;
    return SupervisorMapper.toDomain(data);
  }
  async fetchAll({ project }: { project: Project }): Promise<Supervisor[]> {
    const response = await this.requests.get({
      uri: `/v2/supervisors`,
      params: {
        project_id: project.id,
      },
      headers: this.sessionRepository.getAuthenticationHeader(),
    });

    const data = response.data as SupervisorDTO[];
    return data.map(SupervisorMapper.toDomain);
  }
  async createSupervisors({
    supervisors,
    project,
  }: {
    supervisors: Supervisor[];
    project: Project;
  }): Promise<Supervisor[]> {
    const response = await this.requests.post({
      uri: `/v2/supervisors?project_id=${project.id}`,
      data: supervisors.map(SupervisorMapper.toRepository),
      headers: this.sessionRepository.getAuthenticationHeader(),
    });

    const newSupervisors = response.data as SupervisorDTO[];
    return newSupervisors.map((newSupervisor) => SupervisorMapper.toDomain(newSupervisor));
  }
  async save(supervisor: Supervisor, project: Project): Promise<Supervisor> {
    const response = await this.requests.put({
      uri: `/v2/supervisor/${supervisor.id}`,
      data: SupervisorMapper.toRepository(supervisor),
      headers: this.sessionRepository.getAuthenticationHeader(),
    });
    return SupervisorMapper.toDomain(response.data);
  }
  async deleteSupervisors(supervisorIds: string[]): Promise<void> {
    const requests = supervisorIds.map((supervisorId) => {
      return {
        method: this.requests.delete.bind(this.requests),
        params: {
          uri: `/v2/supervisor/${supervisorId}`,
          headers: this.sessionRepository.getAuthenticationHeader(),
        },
      };
    });

    await this.requests.multipleAsyncWait({ requests });
  }
}
